export default "__VITE_ASSET__DP_X2I2a__"